import { CommonModule, DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { InformationPromotions } from 'src/app/shared/interfaces/promotions/InformationPromotions';
import { CustomNumberFormatPipe } from 'src/app/shared/pipe/custom-number-format.pipe';

@Component({
  selector: 'app-promotions-info',
  standalone: true,
  imports: [
    DatePipe,
    CommonModule,
    CommonModule,
    MatCardModule,
    MatDividerModule,
    CustomNumberFormatPipe,
  ],
  templateUrl: './promotions-info.component.html',
  styleUrl: './promotions-info.component.scss',
})
export class PromotionsInfoComponent {
  @Input() promotionInfo?: InformationPromotions;
}
